import { render, staticRenderFns } from "./PostPollIcon.vue?vue&type=template&id=7cc5addc"
import script from "./PostPollIcon.vue?vue&type=script&lang=js"
export * from "./PostPollIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports